module.exports = __webpack_public_path__ + "static/transactional-email-vs-marketing-email-og-7cca813b73faee94a8c4eb55330fc6da.jpg";